import ECharts from 'echarts';
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import moment from 'moment';
import 'quill/dist/quill.snow.css';
import Vue from "vue";
// import { QuillEditor } from 'vue-quill-editor';
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.prototype.$echarts = ECharts // 挂载ECharts到Vue原型
// Vue.component('QuillEditor', QuillEditor) // 全局注册
//定义一个全局过滤器实现日期格式化
Vue.filter('datefmt', function (input, fmtstring) {//当input为时间戳时，需转为Number类型
    // 使用momentjs这个日期格式化类库实现日期的格式化功能
    return moment(input).format(fmtstring);
});
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");